// app/api/index.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";
import { baseQuery } from "./base-query";
import { showErrorPopup, showNotification } from "../notification-service";
import { NotificationType } from "../types";

export const smePlusApi = createApi({
    reducerPath: "api",
    baseQuery,
    tagTypes: [
        "Lookup",
        "Config",
        "Holidays",
        "Transaction",
        "DashboardConfig",
        "ShiftConfig",
        "WorkShifts",
        "Employee",
        "EmployeeContractTypes",
        "EmployeePersonalDetails",
        "EmployeeDocuments",
        "WeeklySchedules",
        "SalaryComponentType",
        "EmployeeSalaryComponent",
        "EmployeeBasicSalary",
        "DailyAttendanceSummary",
        "LeaveRequests",
        "PayrollConfigs",
        "PackageSubscription",
        "RateLimits",
        "TenantInvoices",
        "Tenant",
        "TenantUsers",
        "TenantFeatures",
        "NatureOfBusinesses",
        "AllFeatures",
        "ReferralCodes",
        "Branch",
        "Teams",
        "AttendanceQR",
        "WorkLog",
        "WorkLogSummary",
        "Project",
        "ProjectTimeLog",
        "Department",
        "RevenueSummary",
    ],
    endpoints: () => ({}),
});

// Correct RTK Query utilities you might actually need:
export const {
    util: {
        resetApiState, // Reset the entire API state
        invalidateTags, // Invalidate specific tags
        updateQueryData, // Update cached query data
    },
} = smePlusApi;

export default smePlusApi;

/**
 * Log RTK Query errors and show notifications
 */
export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action: any) => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood
    if (isRejectedWithValue(action)) {
        if (action.payload && action.payload.data) {
            if (action.payload.status === 403) {
                showNotification(NotificationType.error, "Unauthorized access. You shouldn't be here!");
            } else if (action.payload.data.code === "ERR_RATE_LIMIT_EXCEEDED") {
                let message = action.payload.data.message;

                message += "\n\nCheck your current limits in 'Admin > General > Billing' page.";

                showErrorPopup(message);
            } else {
                // It's an ApiError from your baseQuery
                showNotification(
                    NotificationType.error,
                    action.payload?.data?.message || "An unexpected error occurred",
                );
            }
        }
    }

    return next(action);
};
